import { create, type StateCreator } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import getUpdateInterfacePageAction from '../actions/updateInterfacePageAction';
import getPanicClickActions from './actions/getPanicClickActions';
import { getUpdateBlockForActiveDeviceAction } from './actions/updateBlockStateByActiveDevice';
import type {
  InterfaceStoreState,
  InterfaceStoreStateGetterAndSetter,
  InterfaceStoreType,
  RunnerInterfaceStoreStateInitialValue,
} from './types';

export const createInterfaceStore = (
  initial: RunnerInterfaceStoreStateInitialValue,
  additionalArgs: Omit<InterfaceStoreStateGetterAndSetter, 'set' | 'get'>,
  options?: { initializedFromCache?: boolean },
) => {
  const initializer: StateCreator<InterfaceStoreType> = (set, get) => {
    const args = {
      set,
      get,
      ...additionalArgs,
    };

    const state: InterfaceStoreState = {
      ...initial,
      initializedFromCache: options?.initializedFromCache ?? false,
      interfacePageNamespaces: initial.interfacePageNamespaces ?? {},
      panicClick: {
        popup: null,
        awaitingBlockId: null,
        capturedEmitParams: null,
      },
    };

    return {
      ...state,
      actions: {
        updateInterfacePageAction: getUpdateInterfacePageAction(args),
        updateBlock: {
          // TODO: added for pie, column, progress, bar, to be removed from here
          forActiveDevice: getUpdateBlockForActiveDeviceAction(args),
        },
        panicClickActions: getPanicClickActions(args),
      },
    };
  };

  const store = create<InterfaceStoreType>()(subscribeWithSelector(initializer));

  // auto-sync activeInterfacePage when interfacePages or activeInterfacePageId changes
  store.subscribe(
    (state) => state.interfacePages[state.activeInterfacePageId],
    (activePage) => {
      store.setState({ activeInterfacePage: activePage });
    },
  );

  return store;
};
